import { Accordion, Slider } from "../global";
import { initSection } from "../utils";

/*
  These are scripts for sections on the bundle builder landing page.
  Scripting for the actual bundle builder app can be found inside the seperate bundle-builder folder
*/

document.addEventListener("DOMContentLoaded", (event) => {
  if (document.body.dataset.suffix == "bundle-builder") {
    initSection("accordion-group", Accordion);
    initSection("slider-container", Slider);
  }
});
